/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import { captureAttribution } from "./src/utils/attribution"

// Track contact intent (phone, WhatsApp, email) with one delegated listener.
// These are useful behavioural events, but they are not confirmed leads: a tap
// does not prove that a call connected or a message was sent. Confirmed web
// leads are emitted only after the quote form receives a successful response.
export const onClientEntry = () => {
  if (typeof document === "undefined") return

  // Snapshot any ?utm_*/gclid parameters before the router can navigate away
  // from the landing URL, so the quote form can report which ad sent the lead.
  captureAttribution()

  document.addEventListener(
    "click",
    event => {
      const link =
        event.target && event.target.closest
          ? event.target.closest("a[href]")
          : null
      if (!link) return

      const href = link.getAttribute("href") || ""
      let method
      if (href.startsWith("tel:")) method = "phone"
      else if (href.includes("wa.me") || href.includes("api.whatsapp.com"))
        method = "whatsapp"
      else if (href.startsWith("mailto:")) method = "email"
      else return

      if (typeof window.gtag === "function") {
        window.gtag("event", "contact", { method })
      }
    },
    { capture: true }
  )
}
